import { user_user_verify, user_user_verify_dtk } from '../Models/user';

//============= BACKEND VERIFY LOGIN ============
export const onBackendVerifyLogin = async (data) => {
    let failedData = {
        status: "err",
        data: {},
        statusCode: 500,
        message: "Encountered an internal problem. Try again"
    }
    const reqdata = await user_user_verify(data);

    const result = reqdata && reqdata !== undefined && reqdata.status ? await reqdata.json() : failedData
    if (result.status === 'ok') {
        return { status: result.status, msg: result.msg, data: result.data }
    }
    else {
        return { status: result.status, msg: result.msg }
    }
}

export const onBackendVerifyLoginDtk = async (data) => {
    let failedData = {
        status: "err",
        data: {},
        statusCode: 500,
        message: "Encountered an internal problem. Try again"
    }
    const reqdata = await user_user_verify_dtk(data);

    const result = reqdata && reqdata !== undefined && reqdata.status ? await reqdata.json() : failedData
    if (result.status === 'ok') {
        return { status: result.status, msg: result.msg, data: result.data }
    }
    else {
        return { status: result.status, msg: result.msg }
    }
}